import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const AutomaticRepliesOption: LazyOption = createLazyOption(
    {
        key: 'automaticRepliesOption',
        titleStringKey: 'optionSubcategory_automaticReplies',
        hideTitleInFullOptions: true,
        searchTermsStringKey: 'optionSearchTerms_automaticReplies',
        isHidden: () => {
            return !isFeatureEnabled('cal-automatic-replies') || IsShadowMailboxUser();
        },
        allowedOptionKeys: ['AutomaticReplies'],
    },
    lazyFullModule,
    m => m.default
);
export default AutomaticRepliesOption;
